export const emptySpaceRemover = (arrayWithStrings) => arrayWithStrings.map((item) => item.replace(/\s/g, ''));